import React from "react";
import styled from "styled-components/macro";
import Hero from "src/components/Hero/Hero";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import EventFinished from "src/components/EventFinished";

const HauntedCarnival2026 = () => {
  const { t, i18n } = useTranslation();
  const contentItems = t("hauntedCarnival2026.content.features", {
    returnObjects: true,
  });
  const features = Object.values(contentItems || {});
  const [leadFeature, ...stackedFeatures] = features;

  return (
    <HauntedCarnivalDiv>
      <EventFinished
        scheduleKeyName="hauntedCarnival2026"
        eventType="promotion"
      />
      <h1 className="visually-hidden">{t("hauntedCarnival2026.title")}</h1>
      <Hero
        bgImage="promotions/gaming-machines/haunted-carnival-2026/players-choice-hero-image-2400x800px.jpg"
        image={`promotions/gaming-machines/haunted-carnival-2026/playground-funhouse-logo-2400x974px-${i18n.language}.png`}
        imageAlt={t("hauntedCarnival2026.hero.imageAlt")}
        buttonLink=""
        buttonText=""
        descriptionBgColor="none"
      />
      <container-div>
        <ReactMarkdown className="main-description">
          {t("hauntedCarnival2026.content.description")}
        </ReactMarkdown>
        <div className="feature-grid">
          {leadFeature && (
            <FeatureCard feature={leadFeature} className="feature-lead" />
          )}
          <div className="feature-stack">
            {stackedFeatures.map((feature) => (
              <FeatureCard key={feature.image} feature={feature} />
            ))}
          </div>
        </div>
      </container-div>
    </HauntedCarnivalDiv>
  );
};

const FeatureCard = ({ feature, className = "" }) => (
  <ResponsiveImage
    src={feature.image}
    alt={feature.alt}
    className={`feature-image ${className}`}
  />
);

const HauntedCarnivalDiv = styled.div`
  background: #000;
  text-align: center;
  display: flex;
  flex-direction: column;
  color: #fff;

  .hero_container {
    aspect-ratio: 2400 / 800;
    padding-top: 0;
    background-size: contain;
    background-position: center center;
    justify-content: center;

    .hero_image_container {
      position: absolute;
      inset: 0;
      padding: 0;
      height: 100%;
    }

    .hero_image {
      max-width: min(1100px, 78%);
      max-height: 78%;
      width: auto;
      height: auto;
    }
  }

  .hero_text_container {
    display: none;
  }

  .main-description {
    text-align: center;
    margin: 3rem auto 0;
    max-width: 860px;
    padding: 0 1rem;

    p {
      font-size: 1.15rem;
      line-height: 1.45;
      margin-bottom: 1.35rem;
    }
  }

  .feature-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.75rem;
    max-width: 1100px;
    margin: 2.5rem auto 4rem;
    padding: 0 1rem;
    align-items: stretch;
  }

  .feature-stack {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
  }

  .feature-image,
  .feature-image img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: 767px) {
    .main-description {
      margin-top: 1.5rem;

      p:last-child {
        margin-bottom: 0;
      }
    }

    .feature-grid {
      grid-template-columns: 1fr;
      gap: 0.45rem;
      margin: 1rem auto 1.25rem;
    }
  }
`;

export default HauntedCarnival2026;
